<template>
    <div id="side_bar" :style="style">
        <img class="gil_pic" src="../assets/gilfeig.png">
        <img class="sidebar_curve" src="../assets/sidebar-curve-large.svg">
        <img class="sidebar_curve" src="../assets/sidebar-curve-small.svg">
    </div>
</template>

<script>
export default {
    name: 'AnimatedSideBar',    
    props: {
        backgroundColor: String
    },
    computed: {
        style() {
            return 'background-color: ' + this.backgroundColor
        }
    }
}
</script>


<style scoped>
#side_bar {
    flex-grow: 1;
}

.sidebar_curve {
    position: absolute;
    top: 0;
    right: 0;
}

.gil_pic {
    position: absolute;
    bottom: 0;
    height: 95%;
    transform: translateX(-100%)
}

@media only screen and (max-width: 800px) {
  .gil_pic {
    position: relative;
    transform: translateX(0%);
    transform: translateY(5%); 
  }

  #side_bar {
      height: 500px;
      flex-basis: 100%;
  }
}
</style>
